import * as React from 'react'

const SvgPiIcon = ({ fill = 'white', ...props }) => (
  <svg
    width="42"
    height="35"
    viewBox="0 0 42 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_715_44808)">
      <path
        d="M39.6534 0.642176C38.5641 2.04769 37.1901 3.20721 35.6215 4.04473C34.0528 4.88224 32.3249 5.37887 30.551 5.50207C26.3873 5.89611 22.5519 4.53011 18.7297 3.17722C15.2095 1.94255 11.4661 0.839211 7.70957 1.64043C6.16057 1.98165 4.70414 2.65518 3.44097 3.61446C2.1778 4.57375 1.13801 5.79593 0.393489 7.19647C-0.250117 8.35233 1.61503 9.23234 2.25863 8.07648C3.16995 6.46929 4.54122 5.17147 6.19609 4.34989C7.85095 3.52831 9.71375 3.22052 11.5449 3.46615C12.1097 3.46615 12.6745 3.61064 13.2393 3.71572C13.6096 9.15699 13.4997 14.6203 12.911 20.0423C12.7434 22.4616 12.3028 24.8542 11.5975 27.1745C10.9539 29.0002 9.14127 32.875 6.59312 31.7979C5.37158 31.2725 4.47841 33.1114 5.69995 33.6499C11.5055 36.1062 13.988 27.1876 14.5791 23.2341C15.4739 16.9406 15.7203 10.5718 15.3146 4.22799C17.7314 4.911 20.0826 5.90926 22.4994 6.61854C23.9179 7.04151 25.3738 7.3274 26.847 7.47229C27.4027 13.9435 28.3812 20.3713 29.776 26.7148C30.0519 28.0283 32.1009 27.8181 31.8251 26.5309C30.4415 20.2877 29.4674 13.9608 28.9091 7.5905C31.2634 7.69794 33.6094 7.24423 35.7538 6.2668C37.8982 5.28937 39.7796 3.81622 41.2427 1.9688C42.0308 0.904885 40.4546 -0.421743 39.6534 0.642176Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_715_44808">
        <rect
          width="41.2302"
          height="33.8221"
          fill={fill}
          transform="translate(0.223022 0.248535)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default SvgPiIcon
